import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "warning" }
const _hoisted_3 = { class: "message" }
const _hoisted_4 = { class: "title" }

import AppIcon from '@/components/common/app-icon/AppIcon.vue';
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'OriginalReference',
  props: {
    originalParagraphs: {}
  },
  setup(__props: any) {

const props = __props;

const keys = computed(() => Object.keys(props.originalParagraphs));

const getParagraphClass = (key: string) => {
  const isLast = key === keys.value[keys.value.length - 1];
  const hasBorder = !isLast && keys.value.length > 1;

  return {
    paragraph: true,
    border: hasBorder
  };
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(AppIcon, {
        name: "warning",
        size: "body-l"
      }),
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('doc_reviewing.original_reference.warning')), 1)
    ]),
    _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('doc_reviewing.original_reference.title')), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.originalParagraphs, (paragraph, key) => {
      return (_openBlock(), _createElementBlock("p", {
        class: _normalizeClass(getParagraphClass(key)),
        key: key
      }, _toDisplayString(paragraph), 3))
    }), 128))
  ]))
}
}

})